export const MinTrailPrice: number = 0.01
